import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

const OrderListCreateEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const isEditMode = !!id;

    const handleSave = () => {
        // Add your save logic here
        console.log('Save order');
    };

    const handleCancel = () => {
        navigate('/order-management/order-list');
    };

    return (
        <div className="grid">
            <div className="col-12">
                <Card title={isEditMode ? 'Sipariş Düzenle' : 'Yeni Sipariş'}>
                    {/* Add your form fields here */}
                    <div className="flex justify-content-end gap-2 mt-4">
                        <Button label="İptal" icon="pi pi-times" onClick={handleCancel} severity="secondary" />
                        <Button label="Kaydet" icon="pi pi-check" onClick={handleSave} severity="success" />
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default OrderListCreateEdit; 